import React, { useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../ui/Button';
import { RecoverableSession } from './utils/assessmentSessionRecovery';
import { useFocusTrap } from '../../hooks/useFocusTrap';
interface AssessmentRecoveryModalProps {
  session: RecoverableSession;
  onResume: () => void;
  onAbandon: () => void;
}
export function AssessmentRecoveryModal({
  session,
  onResume,
  onAbandon
}: AssessmentRecoveryModalProps) {
  const focusTrapRef = useFocusTrap(true);
  // Escape key to close (abandon)
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onAbandon();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onAbandon]);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" data-id="element-1111" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1112">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="recovery-title" className="bg-white rounded-3xl shadow-2xl max-w-lg w-full p-8" data-id="element-1113">
          <div className="text-center" data-id="element-1114">
            <div className="text-6xl mb-4" data-id="element-1115">📝</div>
            <h2 id="recovery-title" className="text-2xl font-black text-slate-900 mb-3 tracking-tight" data-id="element-1116">
              Toets hervatten?
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed font-medium" data-id="element-1117">
              Je hebt nog een toets openstaan! Je was bij vraag{' '}
              <strong data-id="element-1118">{session.attempt.answers.length + 1}</strong> van de{' '}
              <strong data-id="element-1119">{session.blueprint.questions.length}</strong>.
            </p>

            <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4 mb-6 text-left" data-id="element-1120">
              <div className="flex items-start gap-3" data-id="element-1121">
                <AlertCircle className="w-5 h-5 text-indigo-600 flex-shrink-0 mt-0.5" data-id="element-1122" />
                <div className="text-sm text-indigo-800 font-medium" data-id="element-1123">
                  <p data-id="element-1124">
                    Je voortgang is bewaard. Je kunt doorgaan waar je gebleven
                    was, of opnieuw beginnen.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-3" data-id="element-1125">
              <Button onClick={onResume} variant="primary" size="lg" fullWidth data-id="element-1126">
                Doorgaan met toets
              </Button>
              <Button onClick={onAbandon} variant="secondary" size="lg" fullWidth data-id="element-1127">
                Opnieuw beginnen
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>;
}